import {
    StyledFinalStepModalBtnWrapper,
    StyledFinalStepModalDescription,
    StyledFinalStepModalTitle,
    StyledIconWrapper,
    StyledModalFinalStep,
} from "./styles";
import { Button } from "@similarweb/ui-components";
import { SWReactIcons } from "@similarweb/icons";
import type { FC } from "react";

type ModalContentFinalStepProps = {
    title: string;
    description: string;
    onClick: () => void;
    buttonText: string;
};

const ModalContentFinalStep: FC<ModalContentFinalStepProps> = ({ title, description, buttonText, onClick }) => {
    return (
        <StyledModalFinalStep>
            <StyledIconWrapper>
                <SWReactIcons
                    iconName="fire-colored"
                    size={"xxl"}
                />
            </StyledIconWrapper>
            <StyledFinalStepModalTitle>{title}</StyledFinalStepModalTitle>
            <StyledFinalStepModalDescription>{description}</StyledFinalStepModalDescription>
            <StyledFinalStepModalBtnWrapper>
                <Button
                    type="primary"
                    onClick={onClick}
                >
                    {buttonText}
                </Button>
            </StyledFinalStepModalBtnWrapper>
        </StyledModalFinalStep>
    );
};

export default ModalContentFinalStep;
